import { useState } from 'react';
import { useNewsletterSettings } from '@/hooks/useNewsletterSettings';

export default function NewsletterSection() {
  const { settings } = useNewsletterSettings();
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d8lk5rhph3sqjdburctg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Container with background image — just the photo, no color overlay */}
        <div
          className="relative rounded-2xl overflow-hidden min-h-[200px] md:min-h-[300px] lg:min-h-[360px]"
          style={{
            backgroundImage: `url(${settings.image})`,
            backgroundSize: settings.bgSize,
            backgroundPosition: settings.bgPosition,
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Content */}
          <div className="relative z-10 flex items-center min-h-[200px] md:min-h-[300px] lg:min-h-[360px] py-8 md:py-14 lg:py-16 px-4 sm:px-8 md:px-12 lg:px-16">
            <div className="max-w-md md:max-w-lg text-center md:text-left bg-white/60 backdrop-blur-[2px] rounded-xl p-4 md:bg-transparent md:backdrop-blur-none md:p-0">
              <h2 className="font-heading font-black text-foreground-950 text-lg sm:text-2xl md:text-3xl lg:text-4xl leading-tight mb-2 md:mb-3">
                {settings.heading}
              </h2>
              <p className="text-foreground-600 text-xs md:text-base mb-4 md:mb-6">
                {settings.subheading}
              </p>

              {submitted ? (
                <div className="flex items-center justify-center md:justify-start gap-2 text-primary-700 font-bold text-xs md:text-sm">
                  <i className="ri-checkbox-circle-line text-lg md:text-xl"></i>
                  Obrigado! Você foi cadastrado com sucesso.
                </div>
              ) : (
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="flex flex-col sm:flex-row gap-2 md:gap-3 max-w-md"
                >
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Seu melhor e-mail"
                    required
                    className="flex-1 px-3 py-2.5 md:px-4 md:py-3 rounded-md text-xs md:text-sm outline-none border border-background-200 focus:border-primary-400 bg-background-50"
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="bg-primary-500 hover:bg-primary-600 disabled:opacity-70 text-white font-bold text-xs md:text-sm px-5 py-2.5 md:px-6 md:py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {loading ? 'Enviando...' : settings.buttonText}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}